export default {"src":"/_next/static/media/star.00f58b83.svg","height":26,"width":26};